export default __webpack_public_path__ + "static/media/general_si_contract_conditions_Fincantieri_si_ENG.a2e5d7f8.pdf";